module.exports = __webpack_public_path__ + "static/media/recargas.2f03ccb3.svg";